module.exports = basename =>
  basename && basename.length > 0
    ? basename.substr(0, basename.length - 1)
    : basename;
